import Loader from "react-js-loader";
import React, { memo, useCallback, useEffect } from "react"

import debounce from "debounce"
import { useFormContext, useWatch } from "react-hook-form"
import useDeepCompareEffect from "use-deep-compare-effect"

const AutoSave = memo(({ defaultValues, onSubmit }) => {
    // Get the closest form methods
    const methods = useFormContext()

    // Save if this function is called and then not called again within 1000ms
    // eslint-disable-next-line
    const debouncedSave = useCallback(
        debounce(() => {
            console.log("Saving")
            console.log(methods.getValues());
            methods.handleSubmit(onSubmit)();
        }, 1000),
        []
    )

    // // Watch all the data, provide with defaultValues from server, this way we know if the new data came from server or where actually edited by user
    // const watchedData = methods.watch(undefined, defaultValues);
    const watchedData = useWatch({
        control: methods.control,
        defaultValue: defaultValues
    })

    // Can't use useEffect anymore :(
    // useEffect(() => {
    //   if (methods.formState.isDirty && methods.formState.isValid) {
    //     debouncedSave();
    //   }
    //   // eslint-disable-next-line
    // }, [watchedData]);

    // So we try something else

    useDeepCompareEffect(() => {
        console.log("Triggered")
        if (methods.formState.isDirty || methods.formState.isValid) {
            debouncedSave()
        }
    }, [watchedData])

    return (
        methods.formState.isSubmitting && (
            <Loader type="bubble-scale" bgColor={"#EF9A9A"} size={100} />
        )
    )
})

AutoSave.displayName = "AutoSave"

export default AutoSave
